
import { WOW } from "wowjs";

(function ($) {
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		let body 		= $( 'body' );
		let header 		= $( 'header' );

		$(".menu-item-has-children").find(".dropdown-toggle").attr("data-toggle", "");

		/**
		 * Mobile Menu - Open/close functionality
		 */
		let mobileMenuContainer 	= header.find('.mobile .menus');
		let mobileMenuOpenBtn		= header.find('.mobile .menu-button-container button.menu-button');
		let mobileMenuCloseBtn		= header.find('.mobile .menus .mobile-menu .main-menu-container .close-button-container button.close-button');
		let mobileMenuItems			= header.find('.mobile .menus .mobile-menu .main-menu-container a');

		$.each(mobileMenuItems, function (i, v) {
			$(v).on('click', function() {
				mobileMenuContainer.removeClass('show');
			});
		});

		// Open
		mobileMenuOpenBtn.on('click', function () {
			mobileMenuContainer.addClass('show');
		});

		// Close
		mobileMenuCloseBtn.on('click', function () {
			mobileMenuContainer.removeClass('show');
		});

		/**
		 * Add class to body when sticky header is showing
		 */
		if ($(window).scrollTop() > 100){
			body.addClass('sticky-header');
		} else {
			body.removeClass('sticky-header');
		}
		$(window).scroll(function(){
			if ($(window).scrollTop() > 100){
				$('body').addClass('sticky-header');
			} else {
				$('body').removeClass('sticky-header');
			}
		});

		/**
		 * Copyright - Display current year
		 */
		let copyrightYear = new Date().getFullYear()
		$( '#copyright-year' ).text( copyrightYear );

		/**
		 * Main Content - Add padding to accommodate fixed header
		 */
		let headerHeight = header.height();
		$( '#content' ).css( 'padding-top', headerHeight );

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);

			return false;
		});

		/**
		 * Banner CTA - use the height of the text area to pad the top of the adjacent block.
		 */
		if ( body.hasClass( 'home' ) && window.innerWidth < 767.98 ) {
			let bannerCTA 			= $( '.cta-block.align-centred' );
			let blockAfterBanner	= bannerCTA.find( '+ .orange-block' );
			let bannerHeight		= bannerCTA.find( '.section-contents' ).height() + 90;
			let videoBtn 			= $('button.btn-video-modal');

			videoBtn.removeAttr('data-target');
			videoBtn.on('click', function(e){
				e.preventDefault();
				window.location.href = "#video";
			});

			blockAfterBanner.css( 'padding-top', bannerHeight );
		}

	});
})(jQuery);